<template>
	<view style="overflow: hidden;"
		:style="{'background':data.config.containerBgColor ||'','border-radius':data.config.borderRadius+'px','color':data.config.textColor ||'','marginTop': data.config.marginTop+'px','marginRight': data.config.marginRight+'px', 'marginBottom': data.config.marginBottom+'px','marginLeft': data.config.marginLeft+'px','paddingTop': data.config.paddingTop+'px','paddingBottom': data.config.paddingBottom+'px','paddingLeft': data.config.paddingLeft+'px','paddingRight': data.config.paddingRight+'px'}">
		
		<view class="ymmp_hd" v-if="!data.config.headerHidden" :style="{'background':data.config.headBgColor ||''}">
			<label class="navTitleLabel" style="width: 100%;"
				:style="{color:data.config.headTitleColor || '','textAlign':data.config.headerTitleAlign,}">{{data.config.headerTitle}}</label>
			<span :style="{color:data.config.headTitleColor || ''}" class="navMoreLabel"
				v-if="data.config.headerShowMoreFlag">查看更多</uni-icons></span>
		</view>

		11111
	</view>
</template>

<script>
	export default {
		name: 'Tpl_Text',
		props: {
			data: {
				type: Object,
				default: () => ({})
			},
			coupons: {
				type: Array,
				default: () => []
			},
		},
		data() {
			return {
				
			}
		},
		mounted() {
			
		},
		methods: {
			click(e) {
				
				uni.navigateTo({
					url: '/pages/mall/item?item_id='+e.itemId
				});

			},
			
		}
	};
</script>

<style scoped>
	.navMenuView {
		width: 100%;
		padding: 0;
		box-sizing: border-box;
	}

	.menuItem {
		display: flex;
		flex-direction: column;
		margin-bottom: 0.625rem;
		/* margin-top: 0; */
		border-radius: 0.25rem;
		overflow: hidden;
		padding: 0.625rem;
		box-sizing: border-box;
		background: white;
	}

	.menuItemNoPadding {
		padding: 0;
		padding-bottom: 0.625rem;
	}

	.navMoreLabel {
		font-size: 0.75rem;
		color: black;
		position: absolute;
		right: 0.625rem;
		display: flex;
		align-items: center;
	}

	.buyButton {
		position: absolute;
		z-index: 100;
		bottom: 0.625rem;
		right: 0.625rem;
		background-color: #EA1A1A;
		border-radius: 0.9375rem;
		font-size: 0.75rem;
		color: white;
		width: 3.5rem;
		line-height: 1.5rem;
		height: 1.5rem;
		display: block;
		text-align: center;
		vertical-align: center;
	}

	.coverPicture {
		height: 6rem;
		width: 6rem;
		background-color: #E8E8E8;
	}

	.row2CoverPicture {
		height:auto;
		width: 100%;
	}

	.bigCoverPicture {
		height: auto;
		width: 100%;
		background-color: #E8E8E8;
	}

	.descContainer {
		display: flex;
		flex: 1;
		flex-direction: column;
		margin-left: 0.625rem;
		position: relative;
	}

	.ymmp_hd {
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		padding-left: 0.625rem;
		padding-right: 0.625rem;
	}

	.navTitleLabel {
		font-size: 1rem;
		color: black;
	}

	.originMonetyLabel {
		font-size: 0.8125rem;
		color: gray;
		margin-top: 0.4375rem;
		text-decoration: line-through;
	}

	.priceMoneyLabel {
		font-size: 1rem;
		color: #EE2C2C;
		margin-top: 0.3rem;
	}

	.labelItem {
		font-size: 0.9375rem;
		color: black;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		line-clamp: 2;
	}
</style>